import axios from 'axios';
import Formatters from './Formatters';

export default {
  mixins: [Formatters],

  props: {
    item: {
      type: Object,
      required: true,
    },

    highlight: {
      type: Boolean,
      required: false,
      default: false,
    },

    topIndex: {
      type: Number,
      required: false,
      default: null,
    },

    totalTopIndexes: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data () {
    const serviceFeeCosts = this.$page.props.settings.service_fee_costs;
    let shippingText = `Veilingkosten: ${this.formatMoney(serviceFeeCosts)}`;
    shippingText += '<br class="hidden md:block" /><span class="md:hidden"> - </span>';

    if (this.item.pickup_only && this.item.pickup_address) {
      shippingText += `Alleen afhalen in: ${this.item.pickup_address}`;
    } else if (this.item.pickup_only) {
      shippingText += 'Alleen afhalen';
    } else if (this.item.shipping_country === null) {
      shippingText += 'Verzendkosten: Gratis';
    } else {
      shippingText += `Verzendkosten: ${this.item.shipping_country} ${this.formatMoney(this.item.shipping_costs)}`;
    }

    return {
      serviceFeeCosts,
      shippingText,
    };
  },

  methods: {
    open () {
      this.$eventHub.$emit('open', this.item);
    },

    favorite () {
      axios.post(this.getFavoriteRoute(), {id: this.item.id})
          .then(({data}) => this.item.favorite = data.favorite)
          .catch(error => {
            if (error.response.status === 403 || error.response.status === 401) {
              this.$eventHub.$emit('login');

              return;
            }

            this.$eventHub.$emit('notification', 'warning', 'unknown error');
          });
    },
  },
};
